function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.600911 6.80078H2.01758V11.0009H0.600911V6.80078Z",
  fill: "#000000"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.21992 10.1114C8.499 10.2374 8.79437 10.3004 9.09896 10.3004C9.40354 10.3004 9.69892 10.2374 9.97729 10.1121L14.7656 7.96094V11.7004C14.7656 13.5387 11.9153 14.5005 9.09896 14.5005C6.28263 14.5005 3.43229 13.5387 3.43229 11.7004V7.96164L8.21992 10.1114Z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.01469 4.06258L8.80636 0.562477C8.99265 0.479174 9.20586 0.479174 9.39215 0.562477L17.1838 4.06258C17.4374 4.17598 17.5996 4.42449 17.5996 4.69959C17.5996 4.9747 17.4374 5.22321 17.1845 5.33661L9.39286 8.83671C9.29936 8.87871 9.19948 8.89971 9.09961 8.89971C8.99973 8.89971 8.89986 8.87871 8.80636 8.83671L1.01469 5.33661C0.761818 5.22321 0.599609 4.9747 0.599609 4.69959C0.599609 4.42449 0.761818 4.17598 1.01469 4.06258Z",
  fill: "#000000"
});

const SvgTrainingTab = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTrainingTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/training_tab.0d0c3f52.svg";
export { ForwardRef as ReactComponent };